@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.workspacesMenu {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.workspacesHeader {
  @include xs-sohne-book;
  color: var(--dark-60);
  margin-bottom: 2px;
}

.divider {
  border-top: 1px solid var(--dark-4);
  margin: 4px;
}

.workspaceMenuItemContent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex: 1;
  gap: 8px;
}

.menuItemContent {
  display: flex;
  align-items: center;
  overflow: hidden;
  gap: 8px;

  &.isSelected {
    font-weight: 500;
  }
}

.pill {
  @include xs-sohne-book;
  display: flex;
  padding: 2px 6px;
  align-items: center;
  border-radius: 16px;
  background: var(--dark-3);
  color: var(--dark-90);
  text-align: center;
}

.backHeader {
  display: flex;
  align-items: center;
  gap: 2px;
  height: 32px;
  padding: 4px 3px 2px 3px;
}
